import React from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from 'react-bootstrap/Table';
import Alert from 'react-bootstrap/Alert';
import { Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import Persona from '../personas/Persona.js'

export default function List() {
  const { isLoading, error, data } = useQuery(['personas'], () => Persona.list(), {
    placeholderData: []
  })

  return (
    <Container className='pt-3'>
      {isLoading && (
        <Row className='pt-3'>
          <Col>
            <Alert variant='info'>
              Loading...
            </Alert>
          </Col>
        </Row>
        )}
      {error && (
        <Row className='pt-3'>
          <Col>
            <Alert variant='danger'>
              {error}
            </Alert>
          </Col>
        </Row>
      )}
      <Row>
        <Col>
          <h1 className='display-6'>Personas</h1>
        </Col>
      </Row>
      <Row>
        <Col>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>First</th>
                <th>Last</th>
                <th>Domain</th>
                <th>Market</th>
                <th>Voicemail</th>
              </tr>
            </thead>
            <tbody>
            { data.map((persona) => (
              <tr key={persona.id}>
                <td>
                  <Link to={`/personas/${persona.id}`}>
                    {persona.id}
                  </Link>
                </td>
                <td className='text-truncate'>{persona.first_name}</td>
                <td className='text-truncate'>{persona.last_name}</td>
                <td className='text-truncate'>{persona.domain}</td>
                <td className='text-truncate'>{persona.market.name}</td>
                <td>
                  <audio controls>
                    <source src={persona.voicemail_audio_url} type="audio/mpeg" />
                  </audio>
                </td>
              </tr>
            ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </Container>
  )
}